import lungSupport from "../../../assets/landingPage/1.png"
import healthyLung from "../../../assets/landingPage/Healthy-lung_lifestyle _page-11.png"

export const BonusesData = [
    {
      id: 1,
      image: lungSupport, 
      alt: 'lungSupport',
      link: 'https://www.facebook.com/groups/699673707101922', 
    },
    {
      id: 2,
      image: healthyLung, 
      alt: 'healthyLung',
      link: 'https://drive.google.com/file/d/1gv5d4NjE-MWRBK4C8RS8HKHThOExQmKD/view?pli=1', 
    },
  ];